import axios from 'axios'
import errorHandler from './error-handler'

const ROTA = 'https://app.rvgeventos.com.br/teleentrega/cargos'

export default {
  async cadastrar(cargoDto) {
    try {
      await axios.post(`${ROTA}`, cargoDto)
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
  async atualizar(cargoDto) {
    try {
      await axios.put(`${ROTA}`, cargoDto)
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
  async buscaPorId(produtoId) {
    try {
      const { data } = await axios.get(`${ROTA}/filtrar-id/${produtoId}`)
      return data
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
  async buscaTodos(pagina = 1) {
    try {
      const { data } = await axios.get(`${ROTA}/todos?pagina=${pagina}`)
      return data
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
  async buscaTodosSemLimite() {
    try {
      const { data } = await axios.get(`${ROTA}/todos-sem-limite`)
      return data
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
  async buscaPermissoesConfiguradas(cargoId) {
    try {
      const { data } = await axios.get(
        `${ROTA}/permissoes-configuradas/${cargoId}`
      )
      return data
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
}
